const experience = [
  {
    role: "Technical Writer",
    company: "Permit.io",
    period: "2025",
    description: [
      "Took the initiative to expand my role beyond technical writing by building the company's Permit MCP Server driven by a strong interest in AI.",
      "Authored the official documentation for the MCP server, providing developers with a foundation for AI-powered integrations.",
      "Wrote a technical tutorial showcasing how developers can integrate Permit.io’s Access Request MCP with AI agent frameworks to build secure, human-in-the-loop workflows."
    ],
    tags: ["MCP Server", "LangGraph", "Documentation", "Article"],
    logo: "/assets/permit.svg"
  },
  {
    role: "Fullstack Developer",
    company: "Fusion",
    period: "2023 - 2025",
    description: [
      "Collaborated with a team of 10 developers to build the startup's web platform.",
      "Built full-stack features, including a referral system and marketplace functionality, from backend APIs to frontend integration.",
      "Integrated APIs for user onboarding and job search/listing features.",
      "Took ownership of increasingly complex features over time, becoming a trusted engineer for implementing core product functionality."
    ],
    tags: ["Next.js", "Express", "MongoDB"],
    logo: "/assets/fusion.svg"
  },
  {
    role: "Technical Writer",
    company: "LogRocket",
    period: "2021 - 2024",
    description: [
      "Authored technical articles that simplified complex developer tools, platforms, and web technologies for engineering audiences.",
      "Authored a product-focused article that led to an interview opportunity with the company behind the featured technology.",
      "Selected to collaborate with an editor to update existing content for the latest Firebase Web SDK releases, ensuring technical accuracy and relevance for developers."
    ],
    tags: ["Developer Education", "Developer Tools"],
    logo: "/assets/logrocket.png"
  }
];

export default experience;
